import React, { useState, useEffect, useContext } from "react";
import { parseCookies } from 'nookies';
import QuoteDetailsNewBrand from "./QuoteDetailsNewBrand";
import QuoteDetails from "./QuoteDetails";
import AppContext from "../../store/app-context";

const QuoteDetailsSelector = () => {
  const appCtx = useContext(AppContext);
  const cookies = parseCookies();

  const [newBrandStyle, setNewBrandStyle] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const isNewBrand = cookies?.rebrandEnabled ?? appCtx?.envProp?.react_app_new_brand_style;
    setNewBrandStyle(isNewBrand);
    setMounted(true);
  }, [appCtx.envProp.react_app_new_brand_style]);

  if (!mounted) return null;

  return newBrandStyle === 'true' ? <QuoteDetailsNewBrand /> : <QuoteDetails />;
};

export default QuoteDetailsSelector;